module.exports = __webpack_public_path__ + "static/hearts-62e7958e7603a401999bb4ff45b1a568.png";